/**
 * FlowUp Page — entry point for the WaSender suite (Phase 1 of the
 * new FlowUp product). Mounts the wasender React app under
 * /flowup/*, wrapped in TanStack Query + the LangProvider + wouter
 * Router using base="/flowup".
 *
 * Wouter and react-router-dom coexist — react-router-dom owns the top
 * level (/flowup/* is a catch-all), wouter takes over inside.
 */
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Router as WouterRouter } from "wouter";
import { LangProvider } from "./flowup/lib/lang";
import FlowUpApp from "./flowup/App";
import "./flowup/index.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

export default function FlowUpPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <LangProvider>
        <WouterRouter base="/flowup">
          <FlowUpApp />
        </WouterRouter>
      </LangProvider>
    </QueryClientProvider>
  );
}
